(() => {
  "use strict";

  window.zag = window.zag || {};

  window.zag.components.ZagCart = class extends (
    window.zag.components.ZagComponent
  ) {
    constructor() {
      super();
    }

    connectedCallback() {
      this.events.add(this, "zag-cart:updated", this.onCartUpdated);
    }

    get cartUtility() {
      return this.cache.get("dom", "cartUtility", () => {
        return window.zag.dom.header.querySelector(
          ".utility-link-container[data-utility='cart']"
        );
      });
    }

    get itemCount() {
      return this.cache.get("dom", "itemCount", () => {
        return this.querySelector(".cart-title").dataset.itemCount;
      });
    }

    get isUpdating() {
      return this.modifiers.has("updating");
    }

    setUpdating() {
      this.modifiers.add("updating");
    }

    clearUpdating() {
      this.modifiers.remove("updating");
    }

    onCartUpdated = (event) => {
      const sectionMarkup = event.detail;
      const sectionHtml = new DOMParser().parseFromString(
        sectionMarkup,
        "text/html"
      );

      this.innerHTML = sectionHtml.querySelector("zag-cart").innerHTML;

      if (window.zag.dom.header.modifiers.has("hidden"))
        window.zag.dom.header.modifiers.remove("hidden");

      if (this.cartUtility.getAttribute("aria-expanded") !== "true") {
        this.cartUtility.querySelector(".utility-link").click();
      }

      const newItemCount =
        sectionHtml.querySelector(".cart-title").dataset.itemCount;

      Array.from(document.querySelectorAll("cart-item-count")).forEach(
        (itemCount) => {
          itemCount.setAttribute("data-count", newItemCount);
        }
      );
    };
  };
  if (!window.customElements.get("zag-cart")) {
    window.customElements.define("zag-cart", window.zag.components.ZagCart);
  }

  window.zag.components.CloseCartButton = class extends (
    window.zag.components.ZagComponent
  ) {
    connectedCallback() {
      this.events.add(this, "click", this.onClick);
    }

    onClick = (event) => {
      const header = window.zag.dom.header;
      header.onUtilityCloseButtonClick(event);
    };
  };
  if (!window.customElements.get("close-cart-button")) {
    window.customElements.define(
      "close-cart-button",
      window.zag.components.CloseCartButton
    );
  }

  window.zag.components.CartDiscountForm = class extends (
    window.zag.components.ZagComponent
  ) {
    constructor() {
      super();
    }

    connectedCallback() {
      this.events.add(this.setDiscountButton, "click", this.setDiscountCode);
    }

    get setDiscountButton() {
      return this.cache.get("dom", "setDiscountButton", () => {
        return this.querySelector(".set-discount-button");
      });
    }

    get discountInput() {
      return this.cache.get("dom", "discountInput", () => {
        return this.querySelector(".cart-discount-input");
      });
    }

    setDiscountCode = async (event) => {
      const button = event.currentTarget;
      const discountCode = this.discountInput.value.trim().toUpperCase();

      if (discountCode === "") return;

      try {
        await fetch("/discount/" + encodeURIComponent(discountCode));

        const sectionId = this.section.id.split("shopify-section-").at(-1);

        const sectionJson = await fetch(`/?sections=${sectionId}`).then(
          (response) => response.json()
        );

        const parentCart = this.closest("zag-cart");
        if (parentCart) {
          parentCart.dispatchEvent(
            new CustomEvent("zag-cart:updated", {
              detail:
                sectionJson[this.section.id.split("shopify-section-").at(-1)],
            })
          );
        }
      } catch (error) {
        console.error("Error applying the coupon code", error);
      }
    };
  };
  if (!window.customElements.get("cart-discount-form")) {
    window.customElements.define(
      "cart-discount-form",
      window.zag.components.CartDiscountForm
    );
  }

  window.zag.components.LineItemCard = class extends (
    window.zag.components.ZagComponent
  ) {
    constructor() {
      super();

      this.debouncedUpdateLine = window.zag.utils.debounce(
        this.updateLine,
        300
      );
    }

    connectedCallback() {
      this.events.add(
        this.removeItemButton,
        "click",
        this.onRemoveItemButtonClick
      );
      this.events.add(
        this.quantityDecreaseButton,
        "click",
        this.onQuantityDecreaseButtonClick
      );
      this.events.add(this.quantityInput, "change", this.onQuantityInputChange);
      this.events.add(
        this.quantityIncreaseButton,
        "click",
        this.onQuantityIncreaseButtonClick
      );
    }

    get removeItemButton() {
      return this.cache.get("dom", "removeItemButton", () => {
        return this.querySelector(".remove-line-item");
      });
    }

    get quantityDecreaseButton() {
      return this.cache.get("dom", "quantityDecreaseButton", () => {
        return this.querySelector(".decrease-line-quantity");
      });
    }

    get quantityIncreaseButton() {
      return this.cache.get("dom", "quantityIncreaseButton", () => {
        return this.querySelector(".increase-line-quantity");
      });
    }

    get quantityInput() {
      return this.cache.get("dom", "quantityInput", () => {
        return this.querySelector(".line-quantity-input");
      });
    }

    get isUpdating() {
      return this.closest("zag-cart").isUpdating;
    }

    onRemoveItemButtonClick = (event) => {
      if (this.isUpdating) return;
      this.updateLine(0);
    };

    onQuantityDecreaseButtonClick = (event) => {
      if (this.isUpdating) return;

      const currentValue = parseInt(this.quantityInput.value);

      this.quantityInput.value = Math.max(currentValue - 1, 0);

      this.debouncedUpdateLine();
    };

    onQuantityIncreaseButtonClick = (event) => {
      if (this.isUpdating) return;

      const currentValue = parseInt(this.quantityInput.value);
      const maxValue = parseInt(this.quantityInput.max);

      this.quantityInput.value = Math.min(currentValue + 1, maxValue);

      this.debouncedUpdateLine();
    };

    onQuantityInputChange = (event) => {
      if (this.isUpdating) return;

      const currentValue = parseInt(this.quantityInput.value);
      const maxValue = parseInt(this.quantityInput.max);
      if (currentValue > maxValue) {
        this.quantityInput.value = maxValue;
      } else if (currentValue < 1) {
        this.quantityInput.value = 1;
      }

      this.updateLine();
    };

    updateLine = async (quantity) => {
      const cart = this.closest("zag-cart");
      if (cart.isUpdating) return;

      try {
        cart.setUpdating();
        this.modifiers.add("updating");

        const cartTemplate =
          window.zag.utils.documentModifiers.has("template:cart");

        const key = this.dataset.lineItemKey;
        const newQuantity = quantity ?? parseInt(this.quantityInput.value);
        const targetSectionId = cartTemplate
          ? window.zag.dom.cart.section.id.split("shopify-section-").at(-1)
          : window.zag.dom.header.section.id.split("shopify-section-").at(-1);

        const cartUpdateJson = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: {
              [key]: newQuantity,
            },
            sections: [targetSectionId],
          }),
        }).then((response) => response.json());

        if (cartTemplate) {
          window.zag.dom.cart.dispatchEvent(
            new CustomEvent("zag-cart:updated", {
              detail: cartUpdateJson.sections[targetSectionId],
            })
          );
        } else {
          window.zag.dom.miniCart.dispatchEvent(
            new CustomEvent("zag-cart:updated", {
              detail: cartUpdateJson.sections[targetSectionId],
            })
          );
        }
      } catch (error) {
        console.error("Error updating line item:", this, error);
      } finally {
        this.modifiers.remove("updating");
        cart.clearUpdating();
      }
    };
  };
  if (!window.customElements.get("line-item-card")) {
    window.customElements.define(
      "line-item-card",
      window.zag.components.LineItemCard
    );
  }

  window.zag.components.LineItemBundleCard = class extends (
    window.zag.components.ZagComponent
  ) {
    connectedCallback() {
      this.removeBundleComponents.forEach((removeBundleComponent) => {
        this.events.add(
          removeBundleComponent,
          "click",
          this.onRemoveBundleComponentClick
        );
      });

      this.events.add(
        this.toggleComponentsButton,
        "click",
        this.handleDescriptionToggle
      );
    }

    get removeBundleComponents() {
      return this.cache.get("dom", "removeBundleComponents", () => {
        return this.querySelectorAll(".remove-line");
      });
    }

    get toggleComponentsButton() {
      return this.cache.get("dom", "toggleComponentsButton", () => {
        return this.querySelector(".component-details-toggle");
      });
    }

    get key() {
      return this.cache.get("dom", "key", () => {
        return this.dataset.lineItemKey;
      });
    }

    get isUpdating() {
      return this.closest("zag-cart").isUpdating;
    }

    onRemoveBundleComponentClick = async (event) => {
      event.preventDefault();

      const cart = this.closest("zag-cart");
      if (cart.isUpdating) return;

      const removeBundleComponent = event.currentTarget;
      const component = removeBundleComponent.closest(".component");
      const category = component.dataset.category;

      try {
        cart.setUpdating();
        this.modifiers.add("updating");

        const bundleData = this.getBundleData();

        await this.removeBundleFromCart(category === "skis");

        if (category !== "skis") {
          const newBundleItems = await this.buildNewBundleItems(
            bundleData,
            category
          );
          if (newBundleItems.length > 0) {
            await this.addBundleToCart(newBundleItems);
          }
        }
      } catch (error) {
        console.error("Error removing bundle component:", error);
      } finally {
        this.modifiers.remove("updating");
        cart.clearUpdating();
      }
    };

    getBundleData() {
      const components = Array.from(this.querySelectorAll(".component"));
      const bundleData = {};

      components.forEach((component) => {
        const category = component.dataset.category;
        const variantId = component.dataset.id;
        const sku = component.dataset.sku;

        bundleData[category] = {
          variantId: parseInt(variantId),
          sku: sku,
        };

        if (category === "montage") {
          const mountingLength = component.dataset.mountingLength;
          const mountingWeight = component.dataset.mountingWeight;

          if (mountingLength)
            bundleData[category].mountingLength = parseInt(mountingLength);
          if (mountingWeight)
            bundleData[category].mountingWeight = parseInt(mountingWeight);
        }
      });

      return bundleData;
    }

    async buildNewBundleItems(bundleData, removedCategory) {
      const items = [];

      const componentsToExclude = new Set([removedCategory]);

      if (removedCategory === "fixations") {
        componentsToExclude.add("couteaux");
        componentsToExclude.add("montage");
      }

      const remainingComponents = Object.keys(bundleData).filter(
        (category) => !componentsToExclude.has(category)
      );

      if (remainingComponents.length === 0) {
        return items;
      }

      let bundleId = "";

      const bundleIdCategories = ["skis", "fixations", "montage"];
      bundleIdCategories.forEach((category) => {
        if (
          remainingComponents.includes(category) &&
          bundleData[category]?.sku
        ) {
          bundleId += bundleId
            ? `_${bundleData[category].sku}`
            : bundleData[category].sku;
        }
      });

      bundleId = await window.zag.utils.getUniqueBundleId(bundleId);

      const skiData = bundleData.skis;
      if (skiData && remainingComponents.length === 1) {
        items.push({
          id: skiData.variantId,
          quantity: 1,
        });
      } else if (skiData) {
        const featuredVariantProperties = {
          _bundleId: bundleId,
        };

        remainingComponents.forEach((category) => {
          let idKey = `_${category}Id`;
          if (category === "fixations") {
            idKey = "_bindingId";
          } else if (category === "peaux") {
            idKey = "_skinId";
          } else if (category === "couteaux") {
            idKey = "_cramponId";
          } else if (category === "montage") {
            idKey = "_mountingId";
          }

          if (category !== "skis" && bundleData[category]) {
            featuredVariantProperties[idKey] = bundleData[category].variantId;
          }
        });

        items.push({
          id: skiData.variantId,
          quantity: 1,
          properties: featuredVariantProperties,
        });
      }

      remainingComponents.forEach((category) => {
        if (category !== "skis" && bundleData[category]) {
          const componentData = bundleData[category];
          const itemProperties = {
            _bundleId: bundleId,
          };

          if (category === "montage") {
            if (componentData.mountingLength) {
              itemProperties._mountingLength = componentData.mountingLength;
            }
            if (componentData.mountingWeight) {
              itemProperties._mountingWeight = componentData.mountingWeight;
            }
          }

          items.unshift({
            id: componentData.variantId,
            quantity: 1,
            properties: itemProperties,
          });
        }
      });

      return items;
    }

    async removeBundleFromCart(shouldRefreshCart = false) {
      const cartTemplate =
        window.zag.utils.documentModifiers.has("template:cart");
      const targetSectionId = cartTemplate
        ? window.zag.dom.cart.section.id.split("shopify-section-").at(-1)
        : window.zag.dom.header.section.id.split("shopify-section-").at(-1);

      const updateBody = {
        updates: {
          [this.key]: 0,
        },
        sections: [targetSectionId],
      };

      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(updateBody),
      });

      if (!response.ok) {
        throw new Error(`Failed to remove bundle: ${response.statusText}`);
      }

      const result = await response.json();

      if (shouldRefreshCart && cartTemplate) {
        window.zag.dom.cart.dispatchEvent(
          new CustomEvent("zag-cart:updated", {
            detail: result.sections[targetSectionId],
          })
        );
      } else if (shouldRefreshCart) {
        window.zag.dom.miniCart.dispatchEvent(
          new CustomEvent("zag-cart:updated", {
            detail: result.sections[targetSectionId],
          })
        );
      }

      return result;
    }

    async addBundleToCart(items) {
      const cartTemplate =
        window.zag.utils.documentModifiers.has("template:cart");
      const targetSectionId = cartTemplate
        ? window.zag.dom.cart.section.id.split("shopify-section-").at(-1)
        : window.zag.dom.header.section.id.split("shopify-section-").at(-1);

      const formData = {
        items: items,
        sections: [targetSectionId],
      };

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`Failed to add bundle: ${response.statusText}`);
      }

      const result = await response.json();

      if (cartTemplate) {
        window.zag.dom.cart.dispatchEvent(
          new CustomEvent("zag-cart:updated", {
            detail: result.sections[targetSectionId],
          })
        );
      } else {
        window.zag.dom.miniCart.dispatchEvent(
          new CustomEvent("zag-cart:updated", {
            detail: result.sections[targetSectionId],
          })
        );
      }

      return result;
    }

    handleDescriptionToggle = (event) => {
      event.stopPropagation();

      const toggle = event.currentTarget;

      if (toggle.getAttribute("aria-expanded") === "true") {
        this.modifiers.add("hidden-components");
        toggle.setAttribute("aria-expanded", "false");
        toggle.querySelector("p").innerHTML = toggle.dataset.moreInformation;
      } else {
        this.modifiers.remove("hidden-components");
        toggle.setAttribute("aria-expanded", "true");
        toggle.querySelector("p").innerHTML = toggle.dataset.lessInformation;
      }
    };
  };
  if (!window.customElements.get("line-item-bundle-card")) {
    window.customElements.define(
      "line-item-bundle-card",
      window.zag.components.LineItemBundleCard
    );
  }
})();
